if (!customElements.get('product-card-information-sel')) {
  customElements.define(
    'product-card-information-sel',
    class ProducCardInfoSel extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      // optionSelectors = this.querySelectorAll('[data-single-option-selector]');
      // variantSelect = this.querySelector('[data-variant-select]');

      constructor() {
        super();

        // this.quantityInput = this.querySelector('.quantity__input');

        // this.colorInputs = this.querySelectorAll('input[name^="Color-"]');
        // this.sizeInputs = this.querySelectorAll('input[name^="Size-"]');
        

        // this.optionSelectors = this.querySelectorAll('.single-option-selector');
        

        // this.optionSelectors.forEach(selector => {
        //   console.log(11, 'change', selector)
        //   selector.addEventListener('change', this.updateVariantSelect.bind(this));
        // });

        this.init();
      }

      init() {
          const that = this

          this.colorSelect = this.querySelector('select[data-color-selector]');
          this.colorInputs = this.colorSelect.options;
          this.sizeInput = this.querySelector('select[name^="options[Size]"]');
          this.sizeInputs = this.sizeInput.options;
  
          this.colorInputArray = Array.from(this.colorInputs);
          this.sizeInputArray = Array.from(this.sizeInput);
  
          this.hiddenVariantSelect = this.querySelector('[data-variant-select]');
  
          this.hiddenVariantSelectArray = Array.from(this.hiddenVariantSelect.options);
          
          // Функція для оновлення активного варіанту
          const updateActiveVariant = (e) => {  
            //console.log('updateActiveVariant clicked on ', e)
            // variant when options is checkbox (swatch)
            // let selectedColor = Array.from(that.colorInputs).find(input => input.checked);
            // let selectedSize = Array.from(that.sizeInputs).find(input => input.checked);
            // variant when options is selector
            let selectedColor = Array.from(that.colorInputs).find(input => input.selected);
            let selectedSize = Array.from(that.sizeInputs).find(input => input.selected);

            let varAvailable = false;

            let colorAvailable = selectedColor.dataset.variantAvailable === 'true'; // Перевіряємо доступність 1
            // let sizeAvailable = selectedSize.dataset.variantAvailable === 'true'; // Перевіряємо доступність 2
            // console.log(`33`, colorAvailable );

            // if(!colorAvailable || !sizeAvailable ){
            //   console.log(`331`, 'unavilable variant' );

            //   this.setUnavailable();
            // }
            
            if (selectedColor && selectedSize) {
              const variantId = e.querySelector('option').dataset.variantIdValue;
              const variantPrice = e.querySelector('option').dataset.variantPriceValue;
              
              let buyButtonInput = this.querySelector(`.js-add-to-cart .product-variant-id`);
              let buyButton = this.querySelector(`.js-add-to-cart .product-form__submit`);
              // const productUrl = selectedColor.dataset.productUrl;

              // const selectedVariantOption = Array.from(that.hiddenVariantSelect.options).find(option => {
              //   // console.log(`44`, option.dataset.price );
              //   return option.textContent.includes(selectedColor.value) && option.textContent.includes(selectedSize.value);
              // });
              const selectedVariantOption = Array.from(that.hiddenVariantSelect.options).find(option => {
                if(option.dataset['option-2'] == selectedColor.value && option.dataset['option-1'] == selectedSize.value ){
                  return option;
                }
              });

              // console.log(`Selected Variant 22`, selectedVariantOption);
              // console.log(`available`, selectedVariantOption.dataset.available);
              // console.log(`Selected Variant ID 33: ${variantId}`);
              // console.log(`Selected Price: ${variantPrice}`);
              // console.log(`Product URL: ${productUrl}`);
              // Тут можна додати логіку для оновлення DOM елементів, наприклад:
              // - Оновити ціну на сторінці // - Оновити URL продукту

              selectedVariantOption.dataset.available == "true" ? buyButton.disabled = false : buyButton.disabled = true

              if (selectedVariantOption) {
                let newPrice = selectedVariantOption.dataset.price;
                let formatedRegularPrice = "$" + Shopify.formatMoney(newPrice);
                let regularPrices = this.querySelectorAll('[data-price-regular]');
                regularPrices.forEach(function(item){
                  item.innerText = formatedRegularPrice;
                });

                const variantId = selectedVariantOption.value;
                // Оновлюємо обране значення в прихованому select
                that.hiddenVariantSelect.value = variantId;
                // Оновлюємо обране значення в buyButton
                buyButtonInput.value = variantId;
              }
            }
          };


          // Додаємо обробники для варіантів кольорів
          that.colorSelect.addEventListener('change', function(e){
            // console.log('change color', e)

            const selectedColor = e.currentTarget.value; // Вибраний колір
            let sizeOptions = that.sizeInput.options;
            let selectedSize = Array.from(that.sizeInputArray).find(option => option.selected);


            // Проходимо через кожну опцію розміру
            that.sizeInputArray.forEach(sizeInput => {
              // const variantId = sizeInput.getAttribute('data-variant-id-value'); // Отримуємо variant ID для розміру
              // const colorVariantId = this.getAttribute('data-variant-id-value'); // Отримуємо variant ID для кольору

              const selectedVariantOption = that.hiddenVariantSelectArray.find(option => {
                // console.log(`551`, selectedColor );
                // console.log(`552`, selectedSize.value );

                if(option.textContent.includes(selectedColor) && option.textContent.includes(sizeInput.value)){
                  if (option.dataset.available == 'true') {
                    sizeInput.classList.remove('disabled');
                  } else {
                    sizeInput.classList.add('disabled');
                  }
                }
                return option.textContent.includes(selectedColor.value) && option.textContent.includes(selectedSize.value);
              });
             });

            // Перевіряємо, чи є активні розміри для вибраного кольору
            // const activeOption = Array.from(sizeOptions).find(sizeInput => !sizeInput.disabled);
            // if (activeOption) {
            //     activeOption.checked = true; // Вибираємо перший доступний розмір
            // } else {
            //   // Якщо немає доступних розмірів, можна скинути вибір (опціонально)
            //   that.querySelector('input[name^="Size-"]:checked').checked = false;
            // }

                updateActiveVariant(e.target);

                // that.updateSizeVariants();
          });
          
          // Додаємо обробники для варіантів розмірів
          that.sizeInput.addEventListener('change', function(e){
            // console.log('change size')

              updateActiveVariant(e.target);
          });

          // Ініціалізація: виклик функції для початкового встановлення активного варіанту
          // updateActiveVariant();
      }

      updateSizeVariants() {
        // console.log(999)

      };

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateVariantSelect() {
        // Отримуємо обрані значення для всіх селекторів варіантів
        const selectedOptions = Array.from(this.optionSelectors).map(select => select.value);

        // Шукаємо варіант, який відповідає обраним значенням
        const matchingVariant = Array.from(this.variantSelect.options).find(option => {
            return option.text.includes(selectedOptions.join(' / '));
        });

        // Якщо знайдений варіант, змінюємо значення прихованого селекта
        if (matchingVariant) {
          this.variantSelect.value = matchingVariant.value;
        }

        let buyButton = this.querySelector(`.js-add-to-cart .product-variant-id`);
        // html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,

        buyButton.value = matchingVariant.value;

      }


      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      

      updateProductInfo(variantId, variantPrice, variantAvailable){
        const buyButton = this.querySelector(`.js-add-to-cart .product-variant-id`);
        // html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,

        buyButton.value = variantId;

        // const variant = this.getSelectedVariant(html);

          //PM
          // this.pickupAvailability?.update(variant);
          // this.updateOptionValues(html);
          // this.updateURL(productUrl, variant?.id);
          // this.updateVariantInputs(variant?.id);

          const updatePrice = () => {
            // document.getElementById('additional-price').innerText = theme.Currency.formatMoney(variant.price);
            // Shopify.formatMoney(cart.total_price).replace('$', 'currencySymbol');
            // this.querySelectorAll('.price-item--regular').innerText = Shopify.formatMoney(variant.price);
            let formatedRegularPrice = Shopify.formatMoney(variantPrice);
            let regularPrices = this.querySelectorAll('[data-price-regular]');
            regularPrices.forEach(function(item){
              item.innerText = Shopify.formatMoney(variantPrice);
            });
            
            // if(variant.compare_at_price){
            //   let compareAtPrices = this.querySelectorAll('[data-compare-price]');
            //   compareAtPrices.forEach(function(item){
            //     item.innerText = Shopify.formatMoney(variant.compare_at_price);
            //     item.classList.remove('hidden');
            //   });
            // } else {
            //   let compareAtPrices = this.querySelectorAll('[data-compare-price]');
            //   compareAtPrices.forEach(function(item){
            //     item.classList.add('hidden');
            //   });
            // }
          }

          updatePrice();


          // this.productForm?.toggleSubmitButton( !variantAvailable ?? true, window.variantStrings.soldOut);

          // publish(PUB_SUB_EVENTS.variantChange, {
          //   data: {
          //     sectionId: this.sectionId,
          //     html,
          //     variant,
          //   },
          // });
      }


      // setQuantityBoundries() {
      //   const data = {
      //     cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
      //     min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
      //     max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
      //     step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
      //   };

      //   let min = data.min;
      //   const max = data.max === null ? data.max : data.max - data.cartQuantity;
      //   if (max !== null) min = Math.min(min, max);
      //   if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      //   this.quantityInput.min = min;

      //   if (max) {
      //     this.quantityInput.max = max;
      //   } else {
      //     this.quantityInput.removeAttribute('max');
      //   }
      //   this.quantityInput.value = min;

      //   publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      // }

      get productForm() {
        return this.querySelector(`product-form`);
      }
      get pickupAvailability() { 
        return this.querySelector(`pickup-availability`);
      }
      get variantSelectors() {
        return this.querySelector(`#${this.id} variant-selects`);
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
